// WAENN — Ficha de producto editorial: seleccion de talla, guia de tallas,
// barra sticky en movil, carrusel de fotos en movil. El envio del
// formulario de compra (Add to cart) lo gestiona el componente nativo de
// Dawn <product-form> (product-form.js); aqui solo sincronizamos la
// variante seleccionada con ese formulario.
//
// FIX (v2) — productos de una sola talla-fieldset visible (p.ej. los
// anillos, que tienen 2 opciones reales -- Color y Tamano del anillo -- pero
// solo se renderiza el fieldset de Tamano porque Color tiene un unico valor
// y se oculta en la ficha): antes, getSelectedOptions()/updateAvailability()
// asumian que el INDICE del fieldset dentro del DOM (0, 1, 2...) coincidia
// siempre con la posicion real de esa opcion en variant.options. Eso es
// falso en cuanto una opcion (como Color) se oculta: el unico fieldset
// visible (Tamano) queda en posicion DOM 0 pero su posicion REAL en
// variant.options es 1 (Color es la 0), asi que la comparacion se hacia
// contra el valor de Color en vez del de Tamano y ninguna variante
// encajaba nunca -- de ahi que los anillos aparecieran siempre como
// "Agotado"/"No disponible" pese a tener stock real en Shopify. Ahora cada
// fieldset y cada input ya llevan data-option-index con la posicion REAL
// (ver main-product-editorial.liquid), asi que se usa ese atributo en vez
// de la posicion dentro del array de fieldsets, y el array "selected" se
// dimensiona segun el numero real de opciones del producto (variants[0].
// options.length), dejando en null cualquier opcion sin fieldset visible
// (como Color) para que actue como comodin y no bloquee el match.
//
// CARRUSEL DE FOTOS EN MOVIL (v3): en movil (<749px, ver waenn-product-
// editorial.css) la galeria pasa de grid 2 columnas a carrusel horizontal
// de scroll NATIVO (overflow-x:auto + scroll-snap-type:x mandatory sobre
// .waenn-pdp__gallery-grid, mismo patron que .waenn-lookbook__track y el
// carrusel de looks de portada). Este archivo solo anade el efecto visual
// "cosmetico" encima de ese scroll nativo -- que punto (.waenn-pdp__
// gallery-dot) se marca como activo, y click en un punto para saltar a esa
// foto -- escuchando el evento 'scroll' nativo del carrusel (no wheel, no
// preventDefault, no hay ningun listener que pueda interferir con el
// scroll vertical de la pagina).

(function () {
  function waennInitProductInfo(root) {
    var sectionId = root.dataset.section;
    var dataScript = document.getElementById('WaennVariantData-' + sectionId);
    if (!dataScript) return;

    var variants;
    try {
      variants = JSON.parse(dataScript.textContent).variants;
    } catch (e) {
      return;
    }
    if (!variants || !variants.length) return;

    var optionsCount = variants[0].options.length;

    var form = root.querySelector('.waenn-pdp__form-el');
    if (!form) return;

    var variantIdInput = form.querySelector('.waenn-pdp__variant-id');
    var addToCartBtn = form.querySelector('[data-add-to-cart]');
    var addToCartText = form.querySelector('[data-add-to-cart-text]');
    var priceWrapper = root.querySelector('.waenn-pdp__price');
    // Textos traducidos por Shopify (locales/es.json, en.default.json, etc.)
    // -- ver data-waenn-t-* en el <product-info> raiz, main-product-
    // editorial.liquid. Asi el JS no pisa la traduccion dinamica del boton
    // al cambiar de variante (antes llevaba 'Add to Cart'/'Agotado' fijos).
    var tAddToCart = root.dataset.waennTAddToCart || 'Add to cart';
    var tSoldOut = root.dataset.waennTSoldOut || 'Sold out';
    var tUnavailable = root.dataset.waennTUnavailable || 'Unavailable';
    var fieldsets = Array.prototype.slice.call(
      form.querySelectorAll('.waenn-pdp__size')
    );

    function getSelectedOptions() {
      var selected = new Array(optionsCount).fill(null);
      fieldsets.forEach(function (fieldset) {
        var index = parseInt(fieldset.dataset.optionIndex, 10);
        if (isNaN(index)) return;
        var checked = fieldset.querySelector('input:checked');
        selected[index] = checked ? checked.value : null;
      });
      return selected;
    }

    function findVariant(selected) {
      return variants.filter(function (variant) {
        return selected.every(function (value, index) {
          return value === null || variant.options[index] === value;
        });
      })[0];
    }

    function updateAvailability(selected) {
      fieldsets.forEach(function (fieldset) {
        var fieldsetIndex = parseInt(fieldset.dataset.optionIndex, 10);
        if (isNaN(fieldsetIndex)) return;
        var inputs = fieldset.querySelectorAll('input[type="radio"]');
        inputs.forEach(function (input) {
          var testSelection = selected.slice();
          testSelection[fieldsetIndex] = input.value;
          var matches = variants.filter(function (variant) {
            return testSelection.every(function (value, index) {
              return value === null || variant.options[index] === value;
            });
          });
          var isAvailable = matches.some(function (variant) {
            return variant.available;
          });
          var label = input.closest('.waenn-pdp__size-option');
          if (!label) return;
          if (isAvailable) {
            label.classList.remove('is-unavailable');
          } else {
            label.classList.add('is-unavailable');
          }
        });
      });
    }

    function updateUI() {
      var selected = getSelectedOptions();
      var variant = findVariant(selected);
      updateAvailability(selected);

      if (!variant) {
        if (addToCartBtn) addToCartBtn.setAttribute('disabled', 'disabled');
        if (addToCartText) addToCartText.textContent = tUnavailable;
        return;
      }

      if (variantIdInput) variantIdInput.value = variant.id;

      if (priceWrapper) {
        var regular = priceWrapper.querySelector('.price-item--regular');
        var sale = priceWrapper.querySelector('.price-item--sale');
        if (variant.compareAtPrice) {
          if (regular) regular.textContent = variant.compareAtPrice;
          if (sale) sale.textContent = variant.price;
        } else if (regular) {
          regular.textContent = variant.price;
        }
      }

      if (addToCartBtn) {
        if (variant.available) {
          addToCartBtn.removeAttribute('disabled');
          if (addToCartText) addToCartText.textContent = tAddToCart;
        } else {
          addToCartBtn.setAttribute('disabled', 'disabled');
          if (addToCartText) addToCartText.textContent = tSoldOut;
        }
      }

      var stickyPrice = document.querySelector(
        '#WaennStickyBar-' + sectionId + ' [data-waenn-sticky-price]'
      );
      if (stickyPrice) stickyPrice.textContent = variant.price;
    }

    form.addEventListener('change', function (e) {
      if (e.target.matches('input[type="radio"][data-option-index]')) {
        updateUI();
      }
    });

    updateAvailability(getSelectedOptions());
  }

  function waennInitSizeGuide(root) {
    var details = root.querySelector('[data-waenn-size-guide]');
    var backdrop = root.querySelector('[data-waenn-size-guide-backdrop]');
    var openTriggers = root.querySelectorAll('[data-waenn-size-guide-open]');
    var closeTriggers = details
      ? details.querySelectorAll('[data-waenn-size-guide-close]')
      : [];
    if (!details) return;

    function open() {
      details.open = true;
      if (backdrop) backdrop.classList.add('is-visible');
      document.body.style.overflow = 'hidden';
    }

    function close() {
      details.open = false;
      if (backdrop) backdrop.classList.remove('is-visible');
      document.body.style.overflow = '';
    }

    openTriggers.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        open();
      });
    });

    closeTriggers.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        close();
      });
    });

    if (backdrop) {
      backdrop.addEventListener('click', close);
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && details.open) close();
    });
  }

  function waennInitWishlist(root) {
    var btn = root.querySelector('[data-waenn-wishlist]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var pressed = btn.getAttribute('aria-pressed') === 'true';
      btn.setAttribute('aria-pressed', pressed ? 'false' : 'true');
    });
  }

  // OFFSET DINAMICO DEL STICKY BAR (fix pie de pagina v1): mismo patron que
  // --waenn-chrome-offset en sections/header.liquid -- se mide la altura
  // REAL del banner sticky "Anadir al carrito" (que puede variar ligeramente
  // segun el tamano de fuente del dispositivo, longitud del titulo, etc.) y
  // se vuelca a una custom property en :root, --waenn-sticky-cta-offset.
  // waenn-product-editorial.css la usa como padding-bottom del grupo de
  // secciones del footer, SOLO en movil y SOLO en la plantilla de producto,
  // para reservar exactamente el espacio que el banner fijo ocupa al final
  // del documento -- sin este padding, el banner (position:fixed; bottom:0)
  // se pinta ENCIMA de los ultimos px de contenido real (la banda negra
  // final "WAENN" del footer) en vez de sobre un hueco reservado, y el
  // usuario nunca puede hacer scroll hasta ver esa banda completa (bug
  // reportado por WAENN: "el banner tapa la banda negra y no deja hacer
  // scroll completo").
  function waennUpdateStickyCtaOffset(bar) {
    if (!bar) return;
    var height = bar.offsetHeight;
    if (!height) return;
    document.documentElement.style.setProperty('--waenn-sticky-cta-offset', height + 'px');
  }

  function waennInitStickyBar(root) {
    var sectionId = root.dataset.section;
    var bar = document.getElementById('WaennStickyBar-' + sectionId);
    var realCta = root.querySelector('[data-add-to-cart]');
    var stickyCta = bar ? bar.querySelector('[data-waenn-sticky-add]') : null;
    if (!bar || !realCta) return;

    if (window.matchMedia('(min-width: 750px)').matches) return;

    waennUpdateStickyCtaOffset(bar);
    window.addEventListener('resize', function () {
      waennUpdateStickyCtaOffset(bar);
    });

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            bar.classList.remove('is-visible');
          } else if (entry.boundingClientRect.top < 0) {
            bar.classList.add('is-visible');
          } else {
            bar.classList.remove('is-visible');
          }
        });
      },
      { threshold: 0 }
    );
    observer.observe(realCta);

    if (stickyCta) {
      stickyCta.addEventListener('click', function () {
        realCta.click();
      });
    }
  }

  // ALTURA DE FOTO = MARGEN A MARGEN, SIN HUECO LATERAL (v28 -- SUSTITUYE A
  // v25/v26). WAENN reporto que la foto del conjunto se veia "contenida",
  // con hueco en blanco a los lados, mientras que en la prenda individual
  // llega de borde a borde. Causa real, diagnosticada comparando ambas
  // fichas con medidas reales: con object-fit:contain (v18, sigue vigente
  // -- WAENN no permite object-fit:cover porque recorta la foto), el hueco
  // lateral aparece en cuanto el contenedor sale proporcionalmente mas
  // ancho/bajo que la foto real (las fotos de producto WAENN son
  // verticales, ratio ancho/alto ~0.77); v25/v26 fijaban la altura de la
  // galeria como una fraccion CONSTANTE del alto disponible (0.52/0.62),
  // sin relacion con la proporcion real de la foto, asi que el contenedor
  // salia demasiado achatado y aparecia el hueco lateral -- en AMBOS tipos
  // de producto por igual (verificado: el hueco tambien existia en la
  // prenda individual dentro de esta misma v25/v26, solo que menos
  // perceptible). La prenda individual en el tema EN VIVO (v16, previo a
  // esta serie de cambios en v17) nunca tuvo ese problema porque usaba el
  // metodo ANTERIOR (v24): medir en tiempo real cuanto ocupa el bloque
  // esencial de compra (desde el borde superior de .waenn-pdp__info-inner
  // hasta el borde inferior de su .waenn-pdp__cta) y darle a la foto TODO
  // el resto del alto disponible bajo el header -- como ese bloque es
  // corto en una prenda individual, a la foto le queda un contenedor
  // alto/vertical, proximo a su proporcion real, y el hueco lateral
  // desaparece o se reduce a casi nada. Ese metodo se sustituyo en v25
  // porque, ANTES de compactar el bloque de piezas del conjunto (ver v27
  // en el liquid/css -- titulo+talla en una sola linea por pieza, hueco
  // entre piezas reducido al minimo), el bloque esencial de un set era
  // mucho mas alto que el de una prenda individual y la foto del conjunto
  // salia visiblemente mas pequena -- el bug original que motivo v25. Con
  // el bloque de conjunto ya compactado, se recupera aqui el metodo v24 --
  // IDENTICO, sin ninguna rama condicional por tipo de producto -- para
  // que la foto del conjunto reciba exactamente el mismo trato que la de
  // una prenda individual: "todo el alto que sobra tras el bloque esencial
  // de compra", sea cual sea ese bloque. Suelo de 300px para pantallas muy
  // pequenas o bloques de compra inusualmente altos (en ese caso extremo
  // se acepta un pequeno scroll en vez de deformar o encoger la foto, tal
  // y como pidio WAENN).
  function waennUpdateGalleryFoldHeight(root) {
    if (!window.matchMedia('(max-width: 749px)').matches) return;

    var gallery = root.querySelector('.waenn-pdp__gallery');
    var infoInner = root.querySelector('.waenn-pdp__info-inner');
    var cta = infoInner ? infoInner.querySelector('.waenn-pdp__cta') : null;
    if (!gallery || !infoInner || !cta) return;

    var chromeOffset = parseFloat(
      getComputedStyle(document.documentElement).getPropertyValue('--waenn-chrome-offset')
    );
    if (isNaN(chromeOffset)) return;

    var available = window.innerHeight - chromeOffset;
    var infoTop = infoInner.getBoundingClientRect().top;
    var ctaBottom = cta.getBoundingClientRect().bottom;
    var essentialHeight = ctaBottom - infoTop;

    var minGalleryHeight = 300;
    var contentBasedHeight = Math.max(minGalleryHeight, available - essentialHeight);

    // ALTO = EL QUE PIDE LA FOTO REAL, SIN EXCEPCION (v28c -- WAENN insistio
    // en que CERO margen lateral es un requisito sin margen de tolerancia,
    // "elimina los margenes de las imagenes de producto", tras detectar que
    // en v28b seguia quedando un resto minimo en el conjunto: el calculo
    // "cuanto sobra tras el bloque esencial" (contentBasedHeight, arriba)
    // sigue vivo como TECHO de seguridad para pantallas muy pequenas o
    // bloques de compra inusualmente altos, pero para el caso normal ya NO
    // se usa Math.min() contra el, porque en el conjunto ese sobrante
    // resultaba ser una fraccion de pixel MENOR que el alto ideal de la
    // foto -- suficiente para reintroducir un hueco lateral apenas
    // perceptible, pero visible en pantalla real. Ahora se calcula el alto
    // EXACTO al que la foto real (por su proporcion, leida de sus
    // atributos width/height, ya presentes en el HTML sin esperar a que
    // cargue) llenaria el ancho completo del contenedor sin ningun sobrante
    // en ninguna direccion, y esa es la altura que se usa SIEMPRE que se
    // pueda calcular -- ya no se recorta contra el bloque de compra. Solo
    // si esa altura ideal fuera menor que el suelo minimo absoluto de
    // legibilidad (minGalleryHeight) se usaria el calculo por contenido en
    // su lugar, como red de seguridad para casos extremos.
    var idealHeight = null;
    var galleryImg = gallery.querySelector('.waenn-pdp__gallery-item img');
    if (galleryImg) {
      var naturalW = parseFloat(galleryImg.getAttribute('width'));
      var naturalH = parseFloat(galleryImg.getAttribute('height'));
      if (naturalW > 0 && naturalH > 0) {
        var galleryWidth = gallery.getBoundingClientRect().width || window.innerWidth;
        idealHeight = galleryWidth * (naturalH / naturalW);
      }
    }

    var galleryHeight = idealHeight && idealHeight >= minGalleryHeight
      ? idealHeight
      : contentBasedHeight;
    galleryHeight = Math.max(minGalleryHeight, galleryHeight);

    document.documentElement.style.setProperty('--waenn-pdp-gallery-h', galleryHeight + 'px');
  }

  // Carrusel de fotos en movil: solo enciende los puntos de posicion
  // (marcar el activo al hacer scroll nativo, y saltar de foto al pulsar
  // uno). No toca el scroll en si -- eso ya lo hace el navegador solo,
  // gracias a overflow-x:auto + scroll-snap-type en el CSS. Si el producto
  // solo tiene una foto (o ninguna), no se renderizan puntos y esta
  // funcion no hace nada.
  function waennInitGalleryCarousel(root) {
    var track = root.querySelector('[data-waenn-gallery-track]');
    if (!track) return;

    // SCROLL VERTICAL SIEMPRE LIBRE SOBRE EL CARRUSEL (v18 bugfix): en
    // movil la galeria es full-bleed y ocupa toda la primera pantalla (ver
    // CSS). Al ser un contenedor con overflow-x:auto pero SIN overflow-y
    // propio, Chrome "reconvierte" cualquier gesto de rueda/trackpad
    // verticalmente dominante en scroll HORIZONTAL de ese mismo elemento
    // (pensado como comodidad para carruseles que solo se navegan con
    // rueda). En la practica eso bloqueaba el paso de FOTO a INFORMACION:
    // el usuario no podia bajar con la rueda/trackpad porque el evento se
    // quedaba atrapado intentando mover el carrusel en horizontal, sin
    // llegar nunca a la pagina (verificado en vivo: scrollY se quedaba
    // clavado en 0 al hacer rueda sobre la foto). Aqui se revierte
    // explicitamente ese comportamiento: si el gesto es predominantemente
    // vertical, se cancela la conversion nativa a horizontal y se hace
    // avanzar la pagina a mano. El swipe tactil real (touchstart/
    // touchmove/touchend) no usa este listener y no se ve afectado -- los
    // navegadores ya distinguen la direccion de un gesto tactil por si
    // solos; este fix es especifico del evento 'wheel' (rueda de raton /
    // trackpad), y solo se activa en movil (en escritorio la galeria es
    // una grid 2x2 sin scroll horizontal propio, nada que corregir ahi).
    if (window.matchMedia('(max-width: 749px)').matches) {
      track.addEventListener(
        'wheel',
        function (e) {
          if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
            e.preventDefault();
            window.scrollBy(0, e.deltaY);
          }
        },
        { passive: false }
      );
    }

    var dotsWrap = root.querySelector('[data-waenn-gallery-dots]');
    if (!dotsWrap) return;

    var dots = Array.prototype.slice.call(
      dotsWrap.querySelectorAll('[data-waenn-gallery-dot]')
    );
    if (!dots.length) return;

    function updateActiveDot() {
      if (window.matchMedia('(min-width: 750px)').matches) return;
      var width = track.clientWidth;
      if (!width) return;
      var index = Math.round(track.scrollLeft / width);
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    }

    track.addEventListener('scroll', updateActiveDot, { passive: true });
    window.addEventListener('resize', updateActiveDot);

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var index = parseInt(dot.dataset.index, 10) || 0;
        track.scrollTo({ left: index * track.clientWidth, behavior: 'smooth' });
      });
    });
  }

  // TALLA EN DESPLEGABLE COMPACTO (v18): en movil, cada fieldset
  // .waenn-pdp__size (tanto la talla del formulario individual como cada
  // pieza del set-builder -- color/arriba/abajo) pasa de una lista
  // siempre visible a un desplegable cerrado por defecto ("TALLA ⌄", ver
  // waenn-product-editorial.css). Se abre/cierra al pulsar su cabecera
  // (data-waenn-size-toggle), se cierra sola en cuanto se elige una
  // opcion, y muestra la opcion elegida junto a la etiqueta cuando esta
  // cerrado (data-waenn-size-current). En escritorio (>=750px) esta
  // funcion no hace nada -- ahi la lista sigue siempre visible, como
  // siempre.
  function waennInitSizeDropdown(root) {
    if (!window.matchMedia('(max-width: 749px)').matches) return;

    root.querySelectorAll('.waenn-pdp__size').forEach(function (fieldset) {
      var toggle = fieldset.querySelector('[data-waenn-size-toggle]');
      var currentEl = fieldset.querySelector('[data-waenn-size-current]');
      var inputs = fieldset.querySelectorAll('input[type="radio"]');

      function syncCurrent() {
        if (!currentEl) return;
        var checked = fieldset.querySelector('input[type="radio"]:checked');
        currentEl.textContent = checked ? checked.value : '';
      }

      function close() {
        fieldset.classList.remove('is-open');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
      }

      if (toggle) {
        toggle.addEventListener('click', function () {
          var isOpen = fieldset.classList.toggle('is-open');
          toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        });
      }

      inputs.forEach(function (input) {
        input.addEventListener('change', function () {
          syncCurrent();
          close();
        });
      });

      syncCurrent();
    });
  }

  function waennInit() {
    document.querySelectorAll('product-info.waenn-pdp').forEach(function (root) {
      waennInitProductInfo(root);
      waennInitSizeGuide(root);
      waennInitWishlist(root);
      waennInitStickyBar(root);
      waennInitGalleryCarousel(root);
      waennInitSizeDropdown(root);

      // Se llama ya al arrancar y de nuevo en 'load'/'resize' -- --waenn-
      // chrome-offset (calculado por sections/header.liquid) puede no
      // estar disponible todavia en DOMContentLoaded segun el orden de
      // ejecucion de los scripts; waennUpdateGalleryFoldHeight() ya se
      // protege a si misma devolviendo pronto si el valor aun no es un
      // numero valido, asi que repetir la llamada es seguro y barato.
      waennUpdateGalleryFoldHeight(root);
      window.addEventListener('load', function () {
        waennUpdateGalleryFoldHeight(root);
      });
      window.addEventListener('resize', function () {
        waennUpdateGalleryFoldHeight(root);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waennInit);
  } else {
    waennInit();
  }
})();
